import styled, { css } from 'styled-components'

import { color, media } from '../../themes'

interface SeparatorBaseProps {
  variant: 'primary' | 'default'
  orientation: 'horizontal' | 'vertical'
  tabletOrientation?: 'horizontal' | 'vertical'
  pcOrientation?: 'horizontal' | 'vertical'
}

const primaryCss = ({ variant }: SeparatorBaseProps) =>
  variant === 'primary' &&
  css`
    &::before {
      content: '';
      height: 7px;
      width: 7px;
      background: ${color('gray.04')};
      border-radius: 50%;
      position: absolute;
    }

    &::after {
      content: '';
      height: 7px;
      width: 7px;
      background: ${color('gray.04')};
      border-radius: 50%;
      position: absolute;
    }
  `

const horizontalCss = ({
  variant,
}: {
  variant: SeparatorBaseProps['variant']
}) => css`
  width: ${variant === 'primary' ? 'calc(100% - 34px)' : '100%'};
  height: 1px;
  margin: ${variant === 'primary' ? '0 17px' : '0'};

  ${variant === 'primary' &&
  css`
    &::before {
      left: -17px;
      top: auto;
    }

    &::after {
      right: -17px;
      bottom: auto;
    }
  `};
`

const verticalCss = ({
  variant,
}: {
  variant: SeparatorBaseProps['variant']
}) => css`
  width: 1px;
  height: auto;
  margin: ${variant === 'primary' ? '17px 0' : '0'};
  align-self: stretch;

  ${variant === 'primary' &&
  css`
    &::before {
      top: -17px;
      left: auto;
    }

    &::after {
      bottom: -17px;
      right: auto;
    }
  `};
`

export const SeparatorBase = styled.div<SeparatorBaseProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${color('gray.04')};
  position: relative;
  box-sizing: border-box;

  ${({ variant, orientation }) =>
    orientation === 'horizontal'
      ? css`
          ${horizontalCss({ variant })}
        `
      : css`
          ${verticalCss({ variant })}
        `}

  ${({ variant, tabletOrientation }) =>
    tabletOrientation === 'vertical' &&
    css`
      ${media.tablet} {
        ${verticalCss({ variant })}
      }
    `}

  ${({ variant, tabletOrientation }) =>
    tabletOrientation === 'horizontal' &&
    css`
      ${media.tablet} {
        ${horizontalCss({ variant })}
      }
    `}

  ${({ variant, pcOrientation }) =>
    pcOrientation === 'vertical' &&
    css`
      ${media.pc} {
        ${verticalCss({ variant })}
      }
    `}
         

  ${({ variant, pcOrientation }) =>
    pcOrientation === 'horizontal' &&
    css`
      ${media.pc} {
        ${horizontalCss({ variant })}
      }
    `}

  ${primaryCss}
`
